import { TweenLite } from 'gsap/TweenLite';
import { ScrollToPlugin } from 'gsap/all';

/* eslint-disable */
// let this be please
const plugins = [ScrollToPlugin];
/* eslint-enable */

export default function scrollTo({ target, offset, parent = window }) {
    const config = {
        y: target,
        autoKill: false,
    };

    if (offset) {
        config.offsetY = offset;
    }

    TweenLite.to(parent, 1, { scrollTo: config });
}
